// Override types coming from src/webapp/features/Heatmaps/heatmap.d.ts
import { moment } from '@hotjar/webapp/lib/moment';

export type AbsoluteDateRange = {
  type: DATE_RANGE_TYPE.ABSOLUTE;
  from: Date;
  to: Date;
};

export type RelativeDateRange = {
  type: DATE_RANGE_TYPE.RELATIVE;
  amount: number;
  unit: DateUnit;
};

export type AllDateRange = {
  type: DATE_RANGE_TYPE.ALL;
};

export type DateRange = RelativeDateRange | AbsoluteDateRange | AllDateRange;

export enum DATE_RANGE_TYPE {
  RELATIVE = 'relative',
  ABSOLUTE = 'absolute',
  ALL = 'all',
}

export function equalsDateRange(dateRange: DateRange, otherDateRange: DateRange): boolean {
  const dateRangeType = dateRange.type;
  switch (dateRange.type) {
    case DATE_RANGE_TYPE.RELATIVE:
      return (
        otherDateRange.type === DATE_RANGE_TYPE.RELATIVE &&
        otherDateRange.unit === dateRange.unit &&
        otherDateRange.amount === dateRange.amount
      );
    case DATE_RANGE_TYPE.ABSOLUTE:
      return (
        otherDateRange.type === DATE_RANGE_TYPE.ABSOLUTE &&
        otherDateRange.from === dateRange.from &&
        otherDateRange.to === dateRange.to
      );
    case DATE_RANGE_TYPE.ALL:
      return otherDateRange.type === DATE_RANGE_TYPE.ALL;
    default:
      throw new Error(`Unknown DateRange type: ${dateRangeType}`);
  }
}

const calculateAbsoluteDateRange = (dateRange: RelativeDateRange): [string, string] => {
  const fromTimestamp = moment().subtract(dateRange.amount, dateRange.unit);

  return [
    new Date(fromTimestamp.unix() * 1000).toISOString(),
    new Date(moment().endOf('day').unix() * 1000).toISOString(),
  ];
};

export const getAbsoluteDateRange = (dateRange: DateRange): [string, string] => {
  switch (dateRange.type) {
    case DATE_RANGE_TYPE.ABSOLUTE:
      return [
        new Date(moment(dateRange.from).startOf('day').unix() * 1000).toISOString(),
        new Date(moment(dateRange.to).endOf('day').unix() * 1000).toISOString(),
      ];
    case DATE_RANGE_TYPE.RELATIVE:
      return calculateAbsoluteDateRange(dateRange);
    case DATE_RANGE_TYPE.ALL:
      return [
        new Date(1979, 3, 13, 7, 20, 0).toISOString(),
        new Date(moment().endOf('day').unix() * 1000).toISOString(),
      ];
    default:
      throw new Error('Unknown date range type');
  }
};
